import React from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button, View } from 'react-bootstrap';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Carousel from 'react-bootstrap/Carousel';

import './styles.css';
import EditCarousel from '../EditCarousel';
import Spinner from 'react-bootstrap/Spinner';
import RestServices from '../services/RestServices.js';

const OverallCategories = '';
const today_Date = new Date();
const dateOffset = 24 * 60 * 60 * 1000;

class TopSellers extends React.Component {
    _isMounted = false;
    state = {
        selectVideoCat: '',
        isLoading: false,
        snapshotDate: null,
        isLoaded: false,
        yesterdayRoutes: [],
        last2DaysRoutes: [],
        last3DaysRoutes: [],
        yesterdayCategoryRouteMap: new Map(),
        last2DaysCategoryRouteMap: new Map(),
        last3DaysCategoryRouteMap: new Map(),
        yesterdayOverallData: [],
        last2DaysOverallData: [],
        last3DaysOverallData: [],
        DataToShow: [],
        RootMapToShow: [],
        dropDownData: [
            'Yesterday Top Sellers',
            'Last 2 Days Top Sellers',
            'Last 3 Days Top Sellers'
        ],
        dropDownValue: 'Yesterday Top Sellers'
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        if (this._isMounted) {
            this.setState({ showLoading: true, selectVideoCat: '' });
        }
        let todayDate = new Date();
        todayDate.setTime(todayDate.getTime() - dateOffset * 1);

        let snapshotDate =
            todayDate.getFullYear() +
            '-' +
            String(parseInt(todayDate.getMonth()) + 1).padStart(2, '0') +
            '-' +
            String(todayDate.getDate()).padStart(2, '0');

        let bodyData = {
            snapshotDate: snapshotDate
        };
        await RestServices.getTopSellers(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            flag: 0,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    
                    let topSellers = [];
                    responseData.yesterdayCategorywiseData.forEach(
                        async (categoryData) => {
                            var Category = categoryData.Category;
                            var Qty = categoryData.Qty;
                            if (
                                topSellers.some(
                                    (item) =>
                                        categoryData.Category === item.Category
                                )
                            ) {
                                topSellers.some(function (el) {
                                    if (el.Category === Category) {
                                        el.Qty = parseInt(el.Qty) + Qty;
                                    }
                                });
                            } else {
                                topSellers.push({
                                    Category: categoryData.Category,
                                    Qty: categoryData.Qty
                                });
                            }
                        }
                    );

                    topSellers = topSellers.sort(function (a, b) {
                        return a['Qty'] > b['Qty'] ? -1 : 1;
                    });
                    
                    let topSellersRoutes = this.getRouteMap(topSellers);

                    topSellersRoutes = this.getRoutesWithKeys(
                        Array.from(topSellersRoutes.keys())
                    );

                    let yesterdayCategoryRouteMap = this.getRouteMap(
                        responseData.yesterdayCategorywiseData
                    );

                    let yesterdayRoutes = this.getRoutesWithKeys(
                        Array.from(yesterdayCategoryRouteMap.keys())
                    );

                    let last2DaysCategoryRouteMap = this.getRouteMap(
                        responseData.last2DaysCategorywiseData
                    );
                    let last2DaysRoutes = this.getRoutesWithKeys(
                        Array.from(last2DaysCategoryRouteMap.keys())
                    );

                    let last3DaysCategoryRouteMap = this.getRouteMap(
                        responseData.last3DaysCategorywiseData
                    );
                    let last3DaysRoutes = this.getRoutesWithKeys(
                        Array.from(last3DaysCategoryRouteMap.keys())
                    );

                    
                    if (this._isMounted) {
                        this.setState({
                            topSellers: topSellers,
                            yesterdayCategoryRouteMap: yesterdayRoutes,
                            yesterdayOverallData:
                                responseData.yesterdayCategorywiseData,

                            DataToShow: responseData.yesterdayCategorywiseData,
                            RootMapToShow: topSellersRoutes,

                            last2DaysCategoryRouteMap: last2DaysRoutes,
                            last2DaysOverallData:
                                responseData.last2DaysCategorywiseData,

                            last3DaysCategoryRouteMap: last3DaysRoutes,
                            last3DaysOverallData:
                                responseData.last3DaysCategorywiseData,
                            showLoading: false,
                            flag1: true
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        flag: 0,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getSceneRouteData(dropDownValue) {
        this.setState({ isLoaded: false, showLoading: true });
        if (dropDownValue == 'Yesterday Top Sellers') {
            if (this._isMounted) {
                this.setState({
                    DataToShow: this.state.yesterdayOverallData,
                    RootMapToShow: this.state.yesterdayCategoryRouteMap
                });
            }
        } else if (dropDownValue == 'Last 2 Days Top Sellers') {
            if (this._isMounted) {
                this.setState({
                    DataToShow: this.state.last2DaysOverallData,
                    RootMapToShow: this.state.last2DaysCategoryRouteMap
                });
            }
        } else if (dropDownValue == 'Last 3 Days Top Sellers') {
            if (this._isMounted) {
                this.setState({
                    DataToShow: this.state.last3DaysOverallData,
                    RootMapToShow: this.state.last3DaysCategoryRouteMap
                });
            }
        } else {
            if (this._isMounted) {
                this.setState({
                    DataToShow: this.state.yesterdayOverallData,
                    RootMapToShow: this.state.yesterdayCategoryRouteMap
                });
            }
        }

        setTimeout(() => {
            if (this._isMounted) {
                this.setState({
                    showLoading: false,
                    isLoaded: true,
                    dropDownValue: dropDownValue
                });
            }
        }, 500);
    }

    getRouteMap(data) {
        let CategoryMap = new Map();
        for (let i = 0; i < data.length; i++) {
            if (CategoryMap.has(data[i].Category)) {
                let categoryValue = CategoryMap.get(data[i].Category);
                categoryValue.push(data[i]);
                CategoryMap.set(data[i].Category, categoryValue);
            } else {
                CategoryMap.set(data[i].Category, [data[i]]);
            }
        }
        return CategoryMap;
    }

    getRoutesWithKeys(categoriesArray) {
        let routeKeyArray = [];
        for (let i = 0; i < categoriesArray.length; i++) {
            routeKeyArray.push(categoriesArray[i].valueOf());
        }
        return routeKeyArray;
    }

    toggleVCat(selectVideoCat) {
        if (this._isMounted) {
            this.setState({
                isLoaded: false,
                showLoading: true,
                selectVideoCat: selectVideoCat
            });
        }

        setTimeout(() => {
            if (this._isMounted) {
                this.setState({ showLoading: false, isLoaded: true });
            }
        }, 500);
    }

    generateColor() {
        const randomColor = Math.floor(Math.random() * 16777215)
            .toString(16)
            .padStart(6, '0');
        return '#' + randomColor;
    }
    
    render() {
        const dropDownData = this.state.dropDownData;
        const OverallData = this.state.DataToShow;
        const RootMapToShow = this.state.RootMapToShow;
        const selectVideoCat = this.state.selectVideoCat;
        const dropDownValue = this.state.dropDownValue;

        return (
            <Container>
                {this.state.showLoading && <Spinner animation="border" />}
                <Row>
                    <Col>
                        <h4>Top Sellers</h4>
                        <hr />
                    </Col>
                </Row>

                {!this.state.selectVideoCat && (
                    <Row className="category_list">
                        {RootMapToShow.map((category) => {
                            return (
                                <Col
                                    key={'id_' + category}
                                    xs={3}
                                    className="category_ibox"
                                    onClick={(bh) => this.toggleVCat(category)}
                                >
                                    <p className="category_icon">
                                        <img
                                            src={
                                                'category/' +
                                                category
                                                    .replace(/ /g, '_')
                                                    .toLowerCase() +
                                                '.jpg'
                                            }
                                        />
                                    </p>
                                    <p>{category.replace(/_/g, ' ')}</p>
                                </Col>
                            );
                        })}
                    </Row>
                )}

                {this.state.selectVideoCat && (
                    <div>
                        <Row>
                            <Col xs={4}>
                                <label>Select Category</label>
                                <Autocomplete
                                    name="Select Category"
                                    value={selectVideoCat}
                                    onChange={(event, newValue) => {
                                        this.toggleVCat(newValue);
                                    }}
                                    id="cate_filter"
                                    options={RootMapToShow.map((arr) => arr)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            margin="dense"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Col>
                            <Col xs={4}></Col>
                            <Col xs={4}>
                                <label>Select days</label>
                                <Autocomplete
                                    name="Select day"
                                    value={dropDownValue}
                                    onChange={(event, newValue) => {
                                        this.getSceneRouteData(newValue);
                                    }}
                                    id="date_filter"
                                    options={this.state.dropDownData.map(
                                        (arr) => arr
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            margin="dense"
                                            variant="outlined"
                                        />
                                    )}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <h5>
                                    {this.state.dropDownValue} in{' '}
                                    {this.state.selectVideoCat}
                                </h5>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <hr />
                            </Col>
                        </Row>
                        {this.state.isLoaded && (
                            <Row>
                                {Object.keys(OverallData).map((key) => {
                                    let item = OverallData[key];
                                    if (selectVideoCat == item.Category) {
                                        
                                        return (
                                            <Col xs={4} key={key}>
                                                <div className="product_box">
                                                    <p>
                                                        <span>
                                                            Date: {getFormattedDateTime(item.Date)}
                                                        </span>
                                                    </p>
                                                    <p>{item.Name}</p>
                                                    <p>
                                                        <b>ASIN: {item.ASIN}</b>
                                                    </p>
                                                    <p className="link_url">
                                                        <a
                                                            onClick={() =>
                                                                window.open(
                                                                    'https://www.amazon.in/dp/' +
                                                                        item.ASIN
                                                                )
                                                            }
                                                        >
                                                            View on Amazon
                                                        </a>
                                                    </p>
                                                </div>
                                            </Col>
                                        );
                                    }
                                })}
                            </Row>
                        )}
                    </div>
                )}
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(TopSellers);
